import { Badge } from '@/components/ui/badge';
import type { KnowledgeBaseVaultRun } from '@/components/knowledge/types';

interface LibrarianActivityListProps {
  runs: KnowledgeBaseVaultRun[];
}

export default function LibrarianActivityList({ runs }: LibrarianActivityListProps) {
  if (runs.length === 0) {
    return (
      <div className="rounded-lg border border-dashed p-6 text-sm text-muted-foreground">
        No Librarian activity yet. Run an ingest or lint pass to start building vault history.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {runs.map((run) => (
        <div key={run.id} className="rounded-lg border bg-card p-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="font-medium capitalize">{run.run_type.replace('-', ' ')}</div>
              <div className="text-xs text-muted-foreground">{new Date(run.created_at).toLocaleString()}</div>
            </div>
            <Badge variant={run.status === 'completed' ? 'secondary' : run.status === 'failed' ? 'destructive' : 'outline'}>
              {run.status}
            </Badge>
          </div>
          <div className="mt-3 text-sm text-muted-foreground">
            {run.notes || 'No notes captured for this run.'}
          </div>
          <div className="mt-3 flex flex-wrap gap-4 text-xs text-muted-foreground">
            <span>{run.input_document_ids.length} input document{run.input_document_ids.length === 1 ? '' : 's'}</span>
            <span>{run.output_page_ids.length} changed page{run.output_page_ids.length === 1 ? '' : 's'}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
